// extracted by mini-css-extract-plugin
module.exports = {"message":"GameOver_message__1fbX1"};